import axios from 'axios'

import {
  claimTap,
  claimTapFailed,
  claimTapSuccess,
  claimStaking,
  claimStakingFailed,
  claimStakingSuccess,
  getStakingData,
  getStakingDataFailed,
  getStakingDataSuccess
} from '../store/actions/main'
import {
  CLAIM_CURRENCY_TYPE,
  CONTRACT_ID_FOR_CUSTOM_FLOW
} from '../constants/app'

const getCustomVestClaimAPIUrl = (contractId, address) => {
  return `${process.env.REACT_APP_SALES_API_URL}vestclaim?contractId=${contractId}&wallet=${address}`
}

const customVestClaimAPIUrl = (contractId, address, type, signedMessage) => {
  return `${process.env.REACT_APP_SALES_API_URL}vestclaim?contractId=${contractId}&wallet=${address}&type=${type}&signedMessage=${signedMessage}`
}

const getStakingDataAPI = (dispatch, address) => {
  dispatch(getStakingData())
  axios
    .get(`${process.env.REACT_APP_SALES_API_URL}stakeclaim?wallet=${address}`)
    .then((response) => {
      dispatch(getStakingDataSuccess(response.data))
    })
    .catch((error) => {
      dispatch(getStakingDataFailed(error))
    })
}

const claimStakingAPI = (dispatch, address, signedMessage) => {
  dispatch(claimStaking())
  axios
    .post(
      `${process.env.REACT_APP_SALES_API_URL}stakeclaim?wallet=${address}&type=${CLAIM_CURRENCY_TYPE.QBX}&signedMessage=${signedMessage}`
    )
    .then((response) => {
      dispatch(claimStakingSuccess(response.data))
    })
    .catch((error) => {
      dispatch(claimStakingFailed(error))
    })
}

const customVestClaimAPI = (dispatch, address, type, signedMessage, id) => {
  dispatch(claimTap(type))
  axios
    .post(
      customVestClaimAPIUrl(
        CONTRACT_ID_FOR_CUSTOM_FLOW[id],
        address,
        type,
        signedMessage
      )
    )
    .then((response) => {
      dispatch(claimTapSuccess(response.data))
    })
    .catch((error) => {
      dispatch(claimTapFailed(error))
    })
}

export {
  getStakingDataAPI,
  claimStakingAPI,
  customVestClaimAPI,
  getCustomVestClaimAPIUrl
}
